module.exports = __webpack_public_path__ + "static/media/butterfly1.f4daff03.svg";